import { FC, ReactNode } from 'react'
import HeaderSpace from '../layout/HeaderSpace'

interface ContainerProps {
  direction?: 'row' | 'col'
  bgColorClass?: string
  className?: string
  children: ReactNode
}

const Container: FC<ContainerProps> = ({ direction, bgColorClass, className, children }) => (
  <div
    className={`min-h-[calc(100vh_-_19rem)] sm:min-h-[calc(100vh_-_7rem)] ${bgColorClass ?? 'bg-base-gray-400 dark:bg-primary-400'}`}
  >
    <div
      className={`py-12 max-w-7xl mx-auto flex ${direction === 'col' ? 'flex-col' : 'flex-row'} justify-center items-center px-2 ${className ?? ''} `}
    >
      <HeaderSpace />
      {children}
    </div>
  </div>
)

export default Container
